module.exports = __webpack_public_path__ + "img/porto_flip.a0682e4f.jpg";